import { messageApi } from '@/context/MessageContext';
import { modalApi } from '@/context/ModalContext';
import { ApiErrorResponse } from './';

/**
 * 默认错误处理函数
 * @param error
 */
const defaultErrorFunc = (error: ApiErrorResponse) => {
  modalApi.success({
    title: '提示',
    content: error.msg,
    okText: '我知道了',
    onOk() {
      modalApi.destroy();
    },
  });
};

export const commonHandle = {
  /**
   * 非管理员，账户余额不足
   */
  1001: defaultErrorFunc,
  /**
   * 管理员，账户余额不足
   */
  1002: defaultErrorFunc,
  /**
   * 没钱，前往充值
   */
  1003: defaultErrorFunc,
  /**
   * 警告类提示信息
   */
  2000: (error: ApiErrorResponse) => {
    messageApi.warning(error.msg);
  },
};

/**
 * 兼容接口正确success 会返回 false 情况
 * @param url
 * @param data
 * @returns
 */
export const compatibleData = (url: string, data?: any) => {
  if (url === '/file/upload' && data?.length) {
    return true;
  }
  return false;
};
